"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParsingError = exports.ParsingErrorImpl = void 0;
const resultFormatter_1 = require("./resultFormatter");
class ParsingErrorImpl {
    constructor(validationId, { cause, action, primaryId, secondaryId, property, value }) {
        this.primaryId = "";
        this.secondaryId = "";
        this.property = "";
        this.value = "";
        const causeFormatter = new resultFormatter_1.ResultFormatter(cause);
        const actionFormatter = new resultFormatter_1.ResultFormatter(action);
        if (primaryId !== undefined) {
            this.primaryId = primaryId;
            causeFormatter.install("primaryId", primaryId);
            actionFormatter.install("primaryId", primaryId);
        }
        if (secondaryId !== undefined) {
            this.secondaryId = secondaryId;
            causeFormatter.install("secondaryId", secondaryId);
            actionFormatter.install("secondaryId", secondaryId);
        }
        if (property !== undefined) {
            this.property = property;
            causeFormatter.install("property", property);
            actionFormatter.install("property", property);
        }
        if (value !== undefined) {
            this.value = value;
            causeFormatter.install("value", value);
            actionFormatter.install("value", value);
        }
        this.cause = causeFormatter.toString();
        this.action = actionFormatter.toString();
        this.validationId = validationId;
    }
}
exports.ParsingErrorImpl = ParsingErrorImpl;
function createParsingError(validationId, errorParams) {
    return new ParsingErrorImpl(validationId, errorParams);
}
exports.createParsingError = createParsingError;
//# sourceMappingURL=parsingErrorImpl.js.map